<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Lin Butler was born in Chiswick and moved to Harlow when she was three. One of five children, she is now back in London. She is a doting mum and grandmother who owned and successfully ran a dress agency for twenty-three years before retiring.</p><br/>
<p style="text-indent:0em">She gets her love of reading from her mum, who always had a book open. This book was written in 2003 and after running out of books to read during the first lockdown of 2020 was re-read and shared with friends who urged her to do something with it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?36a221f6